__turbopack_context__.v({
  "grid": "styles-module-scss-module__R3xtIG__grid",
});
